import { feature, useFeature } from '@/app/context';
import type { SnapshotFrom } from 'xstate';
import type { scheduledBusesMachine } from './scheduled-buses.machine';

export const useScheduledBusesRef = () => feature('scheduledBuses');
export const useScheduledBuses = <Result>(selector: (snapshot: SnapshotFrom<typeof scheduledBusesMachine>) => Result) =>
  useFeature('scheduledBuses', selector);

export function useScheduledBusesActions() {
  const ref = useScheduledBusesRef();
  return {
    chooseRoute: (route: string) => ref.send({ type: 'scheduledBuses.chooseRoute', route }),
    chooseDirection: (direction: string) => ref.send({ type: 'scheduledBuses.chooseDirection', direction }),
    chooseStop: (stop: string) => ref.send({ type: 'scheduledBuses.chooseStop', stop }),
    loadSchedule: () => ref.send({ type: 'scheduledBuses.loadSchedule' }),
    refresh: () => ref.send({ type: 'scheduledBuses.refresh' }),
  };
}
